import Home from "./views/Home/Home";
import Campaigns from "./views/Campaigns/Campaigns";
import CampaignsForm from "./views/CampaignsForm/CampaignsForm";
import UsersTable from "./views/Users/UsersTable";
import Sources from "./views/Sources/Sources";
import Funds from "./views/Funds";
import Categories from "./views/Categories/Categories";
import Pledges from "./views/Pledges/Pledges";

export const routes = [
  // { path: "/", component: <Login /> },
  { path: "/home", component: <Home /> },
  { path: "/categories", component: <Categories /> },
  { path: "/campaigns", component: <Campaigns /> },
  { path: "/campaigns-form", component: <CampaignsForm /> },
  { path: "/user", component: <UsersTable /> },
  { path: "/sources", component: <Sources /> },
  { path: "/funds", component: <Funds /> },
  { path: "/pledges", component: <Pledges /> },
];
